import { mergeConfigPage } from '../../utils/common.utils';

export const normalizeGetByName = (response) => {
  const resp = { ...response }
  delete resp.creativityName;
  delete resp.creativityId;
  delete resp.taggingInfo;
  return resp;
}

export const normalizeConstants = (response) => {
  const resp = { ...response };
  resp.modalAtencionConfig = mergeConfigPage(resp.modalAtencionConfig);

  return resp;
}
